import React from "react";
import { Card, Button, Space, Modal, QRCode } from "antd";
import {
  EditOutlined,
  CheckCircleOutlined,
  StopOutlined,
  DeleteOutlined,
  MessageOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import { cardStyle } from "../styles";

export default function ActionPanel({
  customer,
  updating,
  // onCall,
  onEdit,
  onToggleStatus,
  onDelete,
}) {
  return (
    <Card title="Thao tác" style={cardStyle}>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {/* <Button
          type="primary"
          icon={<PhoneOutlined />}
          onClick={onCall}
          style={{ width: "100%", height: 40, backgroundColor: "#16A66A" }}
        >
          Liên hệ
        </Button> */}
              
        <Button
          size="middle"
          icon={<MessageOutlined />}
          href={`https://zalo.me/${customer.phone}`}
          target="_blank"
          style={{ 
            width: '100%',
            height: 40,
            background: "#0d2d96",
            border: '2px solid white',
            color: 'white',
          }}
        >
          Chat Zalo
        </Button>
        
        <Button
          size="middle"
          icon={<QrcodeOutlined />}
          style={{ 
            width: '100%',
            height: 40,
            background: "#8293f3",
            border: '2px solid white',
            color: 'white',
            fontWeight: 600
          }}
          onClick={() => {
            Modal.info({
              title: 'QR Code Zalo',
              icon: null,
              width: 400,
              centered: true,
              content: (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <QRCode 
                    type="svg" 
                    size={250} 
                    value={`https://zalo.me/${customer.phone}`} 
                    bgColor="#ffffff"
                    style={{ margin: '0 auto' }}
                  />
                  <p style={{ marginTop: 16, color: '#666' }}>
                    Quét mã QR để chat qua Zalo
                  </p>
                </div>
              ),
              okText: 'Đóng'
            });
          }}
        >
          QR Zalo
        </Button>

        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={onEdit}
          style={{ width: "100%", height: 40 }}
        >
          Chỉnh sửa
        </Button>

        <Button
          type={customer.status ? "default" : "primary"}
          icon={customer.status ? <StopOutlined /> : <CheckCircleOutlined />}
          onClick={onToggleStatus}
          loading={updating}
          style={{ width: "100%", height: 40 }}
        >
          {customer.status ? "Vô hiệu hóa" : "Kích hoạt"}
        </Button>

        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={onDelete}
          style={{ width: "100%", height: 40 }}
        >
          Xóa khách hàng
        </Button>

        
      </Space>
    </Card>
  );
}
